import type { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import * as searchApi from '@/services/searchService';

import { sendAnalytics } from '@/services/analyticsService';

import * as userActions from '../user/userActions';

import * as actions from './searchActions';
import type { SearchAction } from './searchTypes';

export function* getSearchesSaga(): SagaIterator {
	try {
		const { data } = yield call(searchApi.getSearches);
		yield put(actions.searchGetSearchesSuccess(data));
	} catch (error) {
		yield put(actions.searchGetSearchesFailure(error));
	}
}

export function* addSearchSaga({ payload }: SearchAction): SagaIterator {
	try {
		const { data } = yield call(
			searchApi.addSearch,
			payload.name!,
			payload.location!,
			payload.listId!,
			payload.params!,
			payload.filters!
		);

		yield put(actions.searchAddSearchSuccess(data));
	} catch (error) {
		yield put(actions.searchAddSearchFailure(error));
	}
}

export function* editSearchSaga({ payload }: SearchAction): SagaIterator {
	try {
		const { data } = yield call(
			searchApi.editSearch,
			payload.id!,
			payload.name!
		);

		yield put(actions.searchEditSearchSuccess(data));
	} catch (error) {
		yield put(actions.searchEditSearchFailure(error));
	}
}

export function* removeSearchSaga({ payload }: SearchAction): SagaIterator {
	try {
		yield call(searchApi.removeSearch, payload.id!);
		const user = yield select(state =>
			state.user.getIn(['authorize', 'user']).toJS()
		);

		if (user && user.email) {
			sendAnalytics({
				type: 'track',
				userId: user.email,
				eventName: 'User deleted a search',
				properties: {
					searchName: payload.name,
					searchProperties: payload
				}
			});
		}
		yield put(actions.searchRemoveSearchSuccess(payload));
	} catch (error) {
		yield put(actions.searchRemoveSearchFailure(error));
	}
}
